import type { MarkerFeature } from "../../../../../utils/models/MarkerFeature";
import type { LineStringFeature } from "../../../../../utils/models/LineStringFeature";
import type { UndoCommand, CommandContext } from "../types";

/**
 * Command for looping a route (adding a marker near the start + connecting linestring).
 * Same shape as AddMarkerCommand.
 */
export class LoopRouteCommand implements UndoCommand {
  readonly type = 'LOOP_ROUTE';
  readonly routeKey: string;

  private marker: MarkerFeature;
  private lineString: LineStringFeature | null;

  constructor(data: {
    routeKey: string;
    marker: MarkerFeature;
    lineString: LineStringFeature | null;
  }) {
    this.routeKey = data.routeKey;
    this.marker = JSON.parse(JSON.stringify(data.marker));
    this.lineString = data.lineString ? JSON.parse(JSON.stringify(data.lineString)) : null;
  }

  undo(ctx: CommandContext): void {
    const route = ctx.state.routes[this.routeKey];
    if (!route) return;

    // Remove last marker
    route.markers.pop();

    // Remove last linestring
    if (this.lineString !== null && route.lineStrings.length > 0) {
      route.lineStrings.pop();
    }

    route.updated_at = new Date();
  }

  redo(ctx: CommandContext): void {
    const route = ctx.state.routes[this.routeKey];
    if (!route) return;

    route.markers.push(JSON.parse(JSON.stringify(this.marker)));
    if (this.lineString !== null) {
      route.lineStrings.push(JSON.parse(JSON.stringify(this.lineString)));
    }

    route.updated_at = new Date();
  }

  updateProvisionalLine(provisionalId: string, realLine: LineStringFeature): boolean {
    if (
      this.lineString &&
      this.lineString.lineStringProperties?.id === provisionalId
    ) {
      this.lineString = JSON.parse(JSON.stringify(realLine));
      return true;
    }
    return false;
  }
}
